import { AdminContainer } from '../components/AdminContainer';

export const StatisticsPage = () => {
  return (
    <AdminContainer clicked='stats'>
      <div>
        <h2>Statistics page</h2>
      </div>
    </AdminContainer>
  );
};
